import { FEATURE_FLAGS } from '../consts/constants';

//Since flipr is not integrated, adding this util

export const getFeatureFlags = () => {
  return {
    [FEATURE_FLAGS.ENABLE_TRACKING_DETAILS_VALIDATION]: {
      enabled: true
    },
    [FEATURE_FLAGS.ENABLE_KEYFRAME_STEPPER_TRACKING]: {
      enabled: true
    },
    [FEATURE_FLAGS.ENABLE_REMAINING_ITEMS_SIDE_PANEL_M3]: {
      enabled: false
    },
    [FEATURE_FLAGS.M3_SIDE_PANEL]: {
      enabled: false
    },
    [FEATURE_FLAGS.ENABLE_RELATIONSHIPS]: {
      enabled: false
    }
  };
};